import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { connect } from 'react-redux';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';

import Card from '@material-ui/core/Card';

import { checkRole } from '../../utils/checkRole';

const BREAKPOINT = 1200;

// const projectCheckboxes = [
//   { value: 'yearComplete', label: 'Year Complete' },
//   { value: 'salePrice', label: 'Sale price/sq.m.' },
//   { value: 'rentalPrice', label: 'Rent price/sq.m.' },
//   { value: 'capitalGain', label: 'Capital gain' },
//   { value: 'rentalYield', label: 'Rental Yield' },
// ];

const projectCheckboxesForGerneral = [
  { value: '', label: 'Project Detail', type: 'header' },
  { value: 'developer', label: 'Developer' },
  { value: 'yearLaunch', label: 'Year Open' },
  { value: 'yearComplete', label: 'Year Completed' },
  { value: 'station', label: 'Station' },
  { value: 'distanceFromBts', label: 'Distance to BTS' },
  { value: 'totalUnits', label: 'Total Units' },
  { value: 'parkingLot', label: 'Parking Lot' },
  { value: 'projectType', label: 'Project Type' },
  { value: 'floor', label: 'Floor' },
  { value: 'furniturePackage', label: 'Furniture Package' },
  { value: 'ceiling', label: 'Ceiling' },
  { value: 'sinkingFund', label: 'Sinking Fund' },
  { value: 'commonFee', label: 'Common Fee' },

  { value: '', label: 'Market Price', type: 'header' },
  { value: 'startingResalePrice', label: 'Avg. Resale Package (For Sale)' },
  { value: 'resalePriceSqm', label: 'Avg. Resale Price /sq.m. (For Sale)' },
  { value: 'rentalPrice', label: 'Avg. Rental Package (For Rent)' },
  { value: 'rentalPriceSqm', label: 'Avg. Rental Price /sq.m. (For Rent)' },
  { value: 'capitalGain', label: 'Cap. Gain' },
  { value: 'rentalYield', label: 'Rental Yield' },
]

const projectCheckboxes = [
  { value: '', label: 'Project Detail', type: 'header' },
  { value: 'developer', label: 'Developer' },
  { value: 'yearLaunch', label: 'Year Open' },
  { value: 'yearComplete', label: 'Year Completed' },
  { value: 'station', label: 'Station' },
  { value: 'distanceFromBts', label: 'Distance to BTS' },
  { value: 'totalUnits', label: 'Total Units' },
  { value: 'parkingLot', label: 'Parking Lot' },
  { value: 'projectType', label: 'Project Type' },
  { value: 'floor', label: 'Floor' },
  { value: 'furniturePackage', label: 'Furniture Package' },
  { value: 'ceiling', label: 'Ceiling' },
  { value: 'sinkingFund', label: 'Sinking Fund' },
  { value: 'commonFee', label: 'Common Fee' },

  { value: '', label: 'Project Status', type: 'header' },
  { value: 'percentSold', label: '% Sold' },
  { value: 'unitsLeft', label: 'Units Left' },
  { value: 'projectStatus', label: 'Project Status' },
  { value: 'constructionStatus', label: 'Construction Status' },
  { value: 'absorptionRateAll', label: 'Absorption Rate / Quarter' },
  { value: 'absorptionRateLastQ', label: 'Absorption Rate Last Quarter' },

  { value: '', label: 'Market Price', type: 'header' },
  { value: 'startingResalePrice', label: 'Avg. Resale Package (For Sale)' },
  { value: 'resalePriceSqm', label: 'Avg. Resale Price /sq.m. (For Sale)' },
  { value: 'rentalPrice', label: 'Avg. Rental Package (For Rent)' },
  { value: 'rentalPriceSqm', label: 'Avg. Rental Price /sq.m. (For Rent)' },
  { value: 'capitalGain', label: 'Cap. Gain' },
  { value: 'rentalYield', label: 'Rental Yield' },

  { value: '', label: 'Project Price', type: 'header' },
  { value: 'launchPriceSqm', label: 'Average of Launch Price' },
  { value: 'startingPrice', label: 'Starting Package (Project)' },
  { value: 'startingCurrentPrice', label: 'Starting Current Package (Project)' },
  { value: 'currentPriceSqm', label: 'Current Price / sq.m.' },


  // { value: 'launchPriceSqm', label: 'Launch Price' },
  // { value: 'currentPriceSqm', label: 'Current Price' },
  // { value: 'startingPrice', label: 'Starting Price (Project)' },
  // {
  //   value: 'currentPriceSqm',
  //   label: 'Starting Price /sq.m. (Project)',
  // },
  
  // { value: '', label: 'Market Price', type: 'header' },
  // { value: 'resalePriceSqm', label: 'Resale Price /sq.m.' },
  // { value: 'rentalPriceSqm', label: 'Rental Price /sq.m.' },
  // { value: 'capitalGain', label: 'Capital Gain' },
  // { value: 'rentalYield', label: 'Rental Yield' },
  // { value: 'startingResalePrice', label: 'Starting Price (Resale)' },
  // { value: 'startingResalePriceSqm', label: 'Starting Price /sq.m. (Resale)' },
  // { value: '', label: 'Project Detail', type: 'header' },
  // { value: 'avgRoomSize', label: 'Avg. Room Size' },
  // { value: 'totalUnits', label: 'Total Units' },
  // { value: 'parkingLot', label: 'Parking Lot' },
];

const facilityCheckboxes = [
  { value: 'shopping', label: 'Shopping' },
  { value: 'office', label: 'Office' },
  { value: 'transportation', label: 'Transportation' },
  { value: 'education', label: 'Education' },
  { value: 'healthy', label: 'Healthy' },
  { value: 'park', label: 'Park' },
];

const Container = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  transition: all 0.6s ease-out;

  @media print {
    display: none;
  }
`;

const LegendWrapper = styled.div`
  font-size: 11px;
  color: #787878;
  margin: 0 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
`;

const ColorBox = styled.div`
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 14px;
  background: ${(props) => props.color || '#ececec'};
`;

const Legend = ({ label, color }) => (
  <LegendWrapper>
    <ColorBox color={color} />
    <Typography style={{ fontSize: 12 }}>{label}</Typography>
  </LegendWrapper>
);

const ListLegendWrapper = styled.div`
  display: block;
  @media (min-width: ${BREAKPOINT}px) {
    display: none;
  }
`;

const ListLegendWrapperDesktop = styled.div`
  display: none;
  @media (min-width: ${BREAKPOINT}px) {
    display: flex;
    flex-direction: row;
    min-width: 600px;
  }
`;

const mapStateToProps = (state, ownProps) => {
  const userRoles = _.get(state, 'domain.user.user.roles');
  return {
    ...ownProps,
    layout: state.domain.design.legend,
    viewOptions: state.domain.map.viewOptionList,
    user: state.domain.user.user,
    userRoles,
  };
};

export default connect(mapStateToProps)(
  class extends React.Component {
    static getDerivedStateFromProps(nextProps, prevState) {
      return {
        checked: nextProps.viewOptions,
      };
    }
    state = {
      open: false,
      checked: [],

      // layout B
      openPopover: false,
    };

    handleClick = () => {
      this.setState({ open: !this.state.open });
    };

    handleToggle = (value) => () => {
      const { dispatch } = this.props;
      const { checked } = this.state;
      const currentIndex = checked.indexOf(value);
      const newChecked = [...checked];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      this.setState({
        checked: newChecked,
      });

      dispatch({
        type: 'DOMAIN/MAP/VIEWOPTION/CHANGE',
        values: newChecked,
      });
    };

    openPopover = (e) => {
      this.setState({
        openPopover: true,
      });
    };

    handleClosePopover = (e) => {
      this.setState({
        openPopover: false,
      });
    };

    render() {
      const { layout, yearRanges, user, userRoles } = this.props;
      const { checked } = this.state;
      const isRoleGeneral = checkRole(userRoles, 'mi-treasure.general-member');
      const viewOptionData = isRoleGeneral ? projectCheckboxesForGerneral : projectCheckboxes;
      // if (_.get(user, 'role') === 'admin') {
      //   projectCheckboxes.unshift({
      //     value: 'absorptionRateFirstQ',
      //     label: 'Absorption Rate (First Q)',
      //   });
      //   projectCheckboxes.unshift({
      //     value: 'absorptionRateAll',
      //     label: 'Absorption Rate (All)',
      //   });
      //   projectCheckboxes.unshift({
      //     value: 'unitsLeft',
      //     label: 'Units Left',
      //   });
      //   projectCheckboxes.unshift({
      //     value: 'percentSold',
      //     label: '%Sold',
      //   });
      //   projectCheckboxes.unshift({
      //     value: '',
      //     label: 'Market (Admin)',
      //     type: 'header',
      //   });
      // }
      if (layout === 'A') {
        return (
          <Container>
            <Card elevation={12}>
              <div>
                <List dense disablePadding>
                  {_.map(yearRanges, (range) => (
                    <ListItem key={`range-${range}`}>
                      <Legend label={range.label} color={range.color} />
                    </ListItem>
                  ))}
                  <Divider />
                  <ListItem
                    button
                    style={{ background: '#f7f7f7' }}
                    onClick={this.handleClick}
                  >
                    <ListItemText primary='View Option' />
                    {this.state.open ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={this.state.open} timeout='auto' unmountOnExit>
                    <List
                      component='div'
                      disablePadding
                      dense
                      style={{ background: '#f7f7f7' }}
                    >
                      {viewOptionData.map((item) => {
                        if (_.get(item, 'type') === 'header') {
                          return (
                            <ListItem
                              button
                              key={item.value}
                              style={{
                                paddingTop: 8,
                                paddingBottom: 8,
                                paddingLeft: 42,
                              }}
                            >
                              <ListItemText
                                disableTypography
                                primary={item.label}
                                style={{
                                  fontSize: 12,
                                  fontFamily: 'SukhumvitSet-Bold',
                                  lineHeight: '1.5em',
                                }}
                              />
                            </ListItem>
                          );
                        } else {
                          return (
                            <ListItem
                              button
                              key={item.value}
                              style={{
                                paddingTop: 8,
                                paddingBottom: 8,
                                paddingLeft: 42,
                              }}
                              onClick={this.handleToggle(item.value)}
                            >
                              <Checkbox
                                checked={checked.indexOf(item.value) !== -1}
                                tabIndex={-1}
                                disableRipple
                              />
                              <ListItemText
                                primary={item.label}
                                style={{ fontSize: 12 }}
                              />
                            </ListItem>
                          );
                        }
                      })}
                    </List>
                  </Collapse>
                </List>
              </div>
            </Card>
          </Container>
        );
      }

      if (layout === 'B') {
        return (
          <Container>
            <Paper
              elevation={12}
              style={{ background: 'white', display: 'flex' }}
            >
              <ListLegendWrapperDesktop>
                {_.map(yearRanges, (range, rIndex) => (
                  <ListItem dense disableGutters key={`range-${rIndex}`}>
                    <Legend label={range.label} color={range.color} />
                  </ListItem>
                ))}
              </ListLegendWrapperDesktop>
              <Button
                buttonRef={(c) => (this.anchorEl = c)}
                onClick={this.openPopover}
                style={{
                  fontSize: '0.8rem',
                  whiteSpace: 'nowrap',
                  width: 100,
                  flexShrink: 0,
                  border: '1px solid #eb6323',
                  color: '#eb6323',
                }}
              >
                View Option
              </Button>
              <Popover
                open={this.state.openPopover}
                anchorEl={this.anchorEl}
                onClose={this.handleClosePopover}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
              >
                <List
                  component='div'
                  disablePadding
                  dense
                  style={{ background: '#f7f7f7' }}
                >
                  <ListLegendWrapper>
                    {_.map(yearRanges, (range) => (
                      <ListItem dense disableGutters key={`range-${range}`}>
                        <Legend label={range.label} color={range.color} />
                      </ListItem>
                    ))}
                    <Divider />
                  </ListLegendWrapper>
                  {viewOptionData.map((item) => {
                    if (_.get(item, 'type') === 'header') {
                      return (
                        <ListItem
                          button
                          key={item.value}
                          style={{ paddingTop: 8, paddingBottom: 8 }}
                        >
                          <ListItemText
                            disableTypography
                            primary={item.label}
                            style={{
                              fontSize: 12,
                              fontFamily: 'SukhumvitSet-Bold',
                              lineHeight: '1.5em',
                            }}
                          />
                        </ListItem>
                      );
                    } else {
                      return (
                        <ListItem
                          button
                          key={item.value}
                          style={{ paddingTop: 8, paddingBottom: 8 }}
                          onClick={this.handleToggle(item.value)}
                        >
                          <Checkbox
                            checked={checked.indexOf(item.value) !== -1}
                            tabIndex={-1}
                            disableRipple
                          />
                          <ListItemText
                            primary={item.label}
                            style={{ fontSize: 12 }}
                          />
                        </ListItem>
                      );
                    }
                  })}
                </List>
              </Popover>
            </Paper>
          </Container>
        );
      }

      return <div />;
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/MapLegend/index.js